<script>
  import { navigateTo } from 'svelte-router-spa';

  function navigateToCustomerPage() {
    navigateTo('/customer');
  }
</script>

<div class="text-center mt-5">
  <button
    on:click|preventDefault={navigateToCustomerPage}
    class="btn btn-primary btn-lg"
  >
    Müşteri Ekle
  </button>
</div>
